/**
 * Lightweight analytics helper.
 * gtag is loaded globally in public/index.html. This wrapper no-ops safely
 * when gtag is unavailable (e.g., ad blockers, tests, SSR).
 */
export const trackEvent = (action, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};

export default trackEvent;
